import React from "react";
import {translate} from "../i18n";
import {langsList} from "../../components/common/Constants";
import "../../styles/header.css";

class Header extends React.Component {
  constructor(props) {
    super(props);

    this.renderLanguagesMenu = this.renderLanguagesMenu.bind(this);
  }
  render() {
    return (
      <div id="header" className="header">
        <div className="groupTitle">
          <div className="preTitle">
            <div id="vintage">The vintage</div>
          </div>
          <div className="title">
            <span id="AR">AR</span>
            <span id="T1">T</span>
            <span id="IS">IS</span>
            <span id="T2">T</span>
            <span id="U">UT</span>
            <span id="OR">OR</span>
          </div>
          <div id="club">Club</div>
        </div>
        {this.renderLanguagesMenu()}       
      </div>
    );
  }

  renderLanguagesMenu() {
    return (<div className="langs">
      <ul>
        {langsList.map(tag=> {
          return <li key={tag}><a href="#" className={tag === this.props.lang ? "lang_selected": "lang"} onClick={e => this.props.updateLang(tag)}>{this.props.t(tag)}</a></li>
        })}
      </ul>
    </div>)
  }
}

export default translate(Header);
